import axios from 'axios'
import Amplify from '@aws-amplify/core'
import i18n from './i18n'
import settings from '../settings'

const url = settings.backendUrl()

const $http = axios.create({
    baseURL: url,
    timeout: 30000,
    responseType: 'json',
    responseEncoding: 'utf8'
})

$http.interceptors.request.use(function(config) {
    config.headers.common = { ...config.headers.common, locale: i18n.locale }
    return Amplify.Auth.currentSession().then((session) => {
        config.headers.common = { ...config.headers.common, authorization: session.getIdToken().getJwtToken() }
        return config
    }).catch(() => {
        return config
    })
})

export default $http
